import Login from "../views/Login";
import VisitorShow from "../views/app/visitor/Visitor";
import VisitorTransmiterShow from "../views/app/visitor/VisitorNode.vue";

const publicRoutes = [
  {
    name: 'landing',
    path: '/',
    component: Login,
    meta: {
      auth: false,
      visi: false
    }
  },
  {
    name: 'login',
    path: '/login',
    component: Login,
    props: true, // To be able to pass props as route params
    meta: {
      auth: false,
      visi: false
    }
  },
  {
    name: 'visitor',
    path: '/visitor',
    component: VisitorShow,
    meta: {
      auth: false,
      visi: true
    }
  },
  {
    name: 'VisitorNode',
    path: "/VisitorNode",
    component: VisitorTransmiterShow,
    meta: {
      auth: false,
      visi: true
    }
  },
  {
    name: 'VisitorWeather',
    path: "/VisitorWeather",
    component: VisitorTransmiterShow,
    meta: {
      auth: false,
      visi: true
    }
  },
]

export default publicRoutes
